<template>
  <el-row type="flex"
          :class="{'row-shadow':isShasow,'bg-color':isBgColor}"
          justify="space-between">
    <slot>
      <h3 style="margin: 0px 0 0 0;color:#4a4a4a;font-weight:bold">{{titleName}}</h3>
    </slot>
    <div v-if="$slots.event"
         @click="$emit('viewDetails',()=>{$emit('detailCallback')})">
      <slot name="event">&gt;</slot>
    </div>
  </el-row>
</template>
<script>
export default {
  props: {
    titleName: [String, Number],
    isShasow: {
      default: false
    },
    isBgColor: {
      default: true
    }
  },
  data () {
    return {

    }
  },
}
</script>
<style lang="scss" scoped>
.el-row {
  box-sizing: border-box;
  line-height: 30px;
  align-items: center;
}
.bg-color {
  background: #fff;
}
.row-shadow {
  box-shadow: 0px 2px 6px 0px rgba(233, 236, 248, 1);
  border-radius: 4px;
}
</style>
